import React, { useEffect, useState } from "react";
import Header from "../common/header";
import PublicIncidentCard from "../specific/publicIncidentCard";
// import { GetComapanyService } from "../../Services/companyService";
import { GetComapanyServiceReduced } from "../../Services/companyService";
import { useParams } from "react-router-dom";
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';

const PublicIncident = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  useEffect(() => {
    const getCompany = async () => {
      try {
        const companyData = await GetComapanyServiceReduced(id);
        setData(companyData);
      } catch (error) {
        console.error(error);
      }
    };
    getCompany();
  }, [id]); // Se ejecutará cada vez que `id` cambie

  useEffect(() => {
    //  console.log(data);
  }, [data]);

  const getHtml = (lang) => {
    if (!data) return null; // Verificar si los datos están disponibles

    const text = data.textCompanies.find(item => item.language === lang && item.enabled);
    return text ? text.text : data.textCompanies.find(item => item.language === 'es' && item.enabled)?.text;
  }

  return (
    <div>
      <Header
        privateWeb={true}
        imageMimeType={data && data.imageMimeType}
        imageData={data && data.imageData}
        helpVideo
        manual={'https://myreportin.com/descargas/manual-de-usuario-Myreportin-Area%20Denunciante.pdf'}
        publicIncident
        companyId={data && data.companyId}
        reloadData={() => setLoading(!loading)}
      />
      {data ? (
        <PublicIncidentCard key={loading} htmlContent={getHtml(currentLanguage)} idCompany={data.companyId} enabled={data.enabled} environmentEnabled={data.environmentEnabled} />
      ) : (
        <div className="public-card-loading-container">
          <div className="public-card-loading-row ">
            <div className="public-card-loading-popup custom-shadow-bold rounded-border-px">
              <Spinner animation="border" className="spinner-bigger" />
            </div>
          </div>
        </div>

      )}
    </div>
  );
};

export default PublicIncident;
